// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_vf6","name":"styles_name__3BnlM","phone":"styles_phone__X_fiT"};